angular.module('swapick')
.controller('SwapCtrl', SwapCtrl);


function SwapCtrl($scope, $http, DataService, $stateParams,
  Categories, $ionicModal, initialLoaderManager, $q, $ionicPopup,
  $ionicScrollDelegate, SwapService, Entities, $timeout, $state,
  $ionicHistory, $ionicLoading, notifyManager, AffidabilityBands) {


  //needed for modal

  $scope.vm = this;
  this.swapId = $stateParams.swapId;
  this.yourObjectId = $stateParams.yourObjectId;
  this.yourUserId = $stateParams.yourUserId;
  this.mySwappableObjects = [];
  this.yourSwappableObjects = [];
  this.toggledDetails = {}
  this.yourUserPromise = $q.defer();
  this.myObjectsIds = $stateParams.myObjectsIds ? $stateParams.myObjectsIds
    .split(",")
    .map(i => parseInt(i)) : [];

  this.candidatesIds = {};
  this.candidatesYourIds = {};

  this.requestSent = false;

  //local cache for involved objects
  this.objectsData = {};
  this.objectsNotFound = [];

  this.canEdit = false;
  this.modified = false;

  this.user = null;
  this.role = null;

  this.dataFrom = {};
  this.dataTo = {};

  this.loader = initialLoaderManager.makeLoader(()=>{
    return Entities.waitForUser()
    .then((u)=>{
      this.user = u;
      return u
    })
    .then(()=>{
      if($stateParams.swapId){
        return DataService.swaps.one(this.swapId).get()
        .then(swapData => {
          this.loadSwapData(swapData)
          return this.refreshObjectsData();
        })
      } else {
        console.log("no swap data, loading from url");
        return this.getSwapDataForObject(this.yourObjectId, this.yourUserId)
        .then(sd => {
          this.loadSwapData(sd);
          let x;
          if(this.myObjectsIds.length){
            let promises = [];
            _.each(this.myObjectsIds,
              itemId => {
                let xx = this.getSwapDataForObject(itemId, this.user.id)
                promises.push(xx);
              }
            );
            x = $q.all(promises)
            .then((responses)=>{
              let items = _.map(responses, r => r.oggetti)
              this.me.items = _.flatten(items);
              return this.me.items;
            })
          } else {
            x = $q.when(true)
          }

          return x.then(()=>{
            return this.refreshObjectsData();
          })
        })
      }
    })
    .then(() => {
      const userBand = AffidabilityBands.getBandByPercent(this.user.affidabilita * 100)
      const yourUserBand = AffidabilityBands.getBandByPercent(this.yourUser.affidabilita * 100);

      if (userBand.rank < yourUserBand.rank) {
        // Spedisci tu
        this.shipperUser = this.user;
        this.shipperUserReason = 'affidabilita';
      } else if (userBand.rank > yourUserBand.rank) {
        // Spedisce lui
        this.shipperUser = this.yourUser;
        this.shipperUserReason = 'affidabilita';
      } else {
        if (this.yourUser.transazioni > this.user.transazioni) {
          // Spedisci tu
          this.shipperUser = this.user;
          this.shipperUserReason = 'transazioni';
        } else if (this.yourUser.transazioni < this.user.transazioni) {
          // Spedisce lui
          this.shipperUser = this.yourUser;
          this.shipperUserReason = 'affidabilita';
        } else {
          // Big trouble è_é
          console.info('cant found the shipper user');
        }
      }
      console.log('Shipper user', this.shipperUser);
    })
  }, false);

  $scope.$on('$ionicView.beforeEnter', () => {
      this.loader.load();
  });


  this.getSwapDataForObject = (objectId, userId) => {
    return DataService.items.one(objectId)
    .get({user_id:userId})
    .then(obj => {

      return {
        destinatario : obj.posseduto_da[0].user,
        proponente : this.user,
        oggetti : [
          { oggetto:obj.plain(), utente:obj.posseduto_da[0].user.id}
        ]
      }
    });
  }


  this.loadSwapData = (swapData) => {
    this.swapData = swapData;

    let propItems = _.filter(swapData.oggetti, it => it.utente == swapData.proponente.id);
    let destItems = _.filter(swapData.oggetti, it => it.utente == swapData.destinatario.id);


    let role = null;
    if(this.user.id === swapData.destinatario.id){
      role = 'destinatario';
    }
    if(this.user.id === swapData.proponente.id){
      role = 'proponente';
    }

    this.dataFrom = {
      money : _.find(propItems, item => item.ecoin ),
      items : _.filter(propItems, item =>item.oggetto )
    },

    this.dataTo = {
      money : _.find(destItems, item => item.ecoin ),
      items : _.filter(destItems, item => item.oggetto )
    }

    if(role=='destinatario'){
      this.you = this.dataFrom;
      this.me = this.dataTo;
      this.yourUser = swapData.proponente;
    } else {
      this.me = this.dataFrom;
      this.you = this.dataTo;
      this.yourUser = swapData.destinatario;
    }

    this.yourUserPromise.resolve(true);

    this.role = role;
    this.canEdit = (this.role == 'destinatario' && (swapData.stato == 'proposta')) || (this.role == 'proponente' && !swapData.stato);

    // Init canidates ids
    const itemsToCandidateIds = (items) => items.reduce((r, item) => _.merge(r, { [item.oggetto.id]: true }), {});
    this.candidatesIds = itemsToCandidateIds(this.me.items);
    this.candidatesYourIds = itemsToCandidateIds(this.you.items);
  }


  this.addMyMoney = () => {
    $scope.tempData = {};
    $scope.tempData.tempMoney = this.me.money ? this.me.money.ecoin || null : null;;

    // An elaborate, custom popup
    var myPopup = $ionicPopup.show({
      template: `<input type="number" min="0" step="1" ng-model="tempData.tempMoney">`,
        title: 'Aggiungi denaro',
        cancelText: 'Annulla',
        subTitle: 'Inserisci l\'importo in €',
        scope: $scope,
        buttons: [
          { text: 'Annulla', onTap : (e)=>{
            return this.myMoney;
            myPopup.close() }
          },
          {
            text: '<b>OK</b>',
            type: 'button-positive',
            onTap: (e) => {
              return $scope.tempData.tempMoney;
              if (!SwapCtrl.tempMoney) {
                //don't allow the user to close unless he enters wifi password
                e.preventDefault();
              } else {

              }
            }
          }
        ]
  });

  myPopup.then((res) => {
    console.log('Tapped!', res);
    this.me.money = res ? { ecoin: res} : {};
  });

  };

  this.removeMyMoney = () => {
    this.me.money = 0;
  }


  this.loadCandidatesPage = () => {

    return SwapService.loadCandidatesPage(
      this.mySwappableObjects.length,
      this.yourUser.id
    ).then(data=>{
      this.meta = data.resp;
      this.mySwappableObjects = this.mySwappableObjects.concat(data.objs);
      return data;
    })
  }

  this.hasMoreCandidatesToLoad = () =>{
    return this.meta && this.meta.next;
  }

  this.loadMoreCandidates = ()=>{
    return this.yourUserPromise.promise.then(()=>{
      return this.loadMoreCandidatesUnsafe();
    })
  }
  this.loadMoreCandidatesUnsafe= () => {
    return this.loadCandidatesPage().then(()=>{
      return $scope.$broadcast('scroll.infiniteScrollComplete');
    })
  }
  /*
  this.toggleCandidate = (candidate) =>{
    let objs = this.me.items || [];
    let found = _.find(objs, i => {
      return i.oggetto.id == candidate.id
    })
    if(found){
      console.log("should remove", found)
      delete this.candidatesIds[found.oggetto.id];
      this.me.items = _.filter(this.me.items,  i => {
        return i.oggetto.id != found.oggetto.id
      });

      return
    } else {
      console.log("should add", candidate)
      this.candidatesIds[candidate.id] = true;

      this.me.items = this.me.items || [];
      this.me.items.push({
        utente:this.user.id,
        oggetto : candidate
      })
      this.objectsData[candidate.id] = candidate.plain ? candidate.plain() : candidate;
    }
  };
  */



  this.loadYourCandidatesPage = () => {
    return DataService.owned
    .getList({user_id:this.yourUser.id})
    .then(data=>{
      console.log(data)
      this.metaYours = data.resp;
      this.yourSwappableObjects = this.yourSwappableObjects.concat(data);
      return data;
    })
  }

  this.hasMoreYourCandidatesToLoad = () =>{
    return this.metaYours && this.metaYours.next;
  }

  this.loadMoreYourCandidates = ()=>{
    return this.yourUserPromise.promise.then(()=>{
      return this.loadMoreYourCandidatesUnsafe();
    })
  }
  this.loadMoreYourCandidatesUnsafe= () => {
    return this.loadCandidatesPage().then(()=>{
      return $scope.$broadcast('scroll.infiniteScrollComplete');
    })
  }

  this.toggleCandidate = (candidate) =>{
    let objs = this.me.items || [];
    let found = _.find(objs, i => {
      return i.oggetto.id == candidate.id
    })
    if(found){
      console.log("should remove", found)
      delete this.candidatesIds[found.oggetto.id];
      this.me.items = _.filter(this.me.items,  i => {
        return i.oggetto.id != found.oggetto.id
      });

      return
    } else {
      console.log("should add", candidate)
      this.candidatesIds[candidate.id] = true;

      this.me.items = this.me.items || [];
      this.me.items.push({
        utente:this.user.id,
        oggetto : candidate
      })
      this.objectsData[candidate.id] = candidate.plain ? candidate.plain() : candidate;
    }
  };


  this.toggleYourCandidate = (candidate) =>{
    let objs = this.you.items || [];
    let found = _.find(objs, i => {
      return i.oggetto.id == candidate.id
    })
    if(found){
      console.log("should remove", found)
      delete this.candidatesYourIds[found.oggetto.id];
      this.you.items = _.filter(this.you.items,  i => {
        return i.oggetto.id != found.oggetto.id
      });

      return
    } else {
      console.log("should add", candidate)
      this.candidatesYourIds[candidate.id] = true;

      this.you.items = this.you.items || [];
      this.you.items.push({
        utente:this.yourUser.id,
        oggetto : candidate
      })
      this.objectsData[candidate.id] = candidate.plain ? candidate.plain() : candidate;
    }
  };



  this.toggleDetail = (id) => {
    this.toggledDetails[id] = !!!this.toggledDetails[id];
    $ionicScrollDelegate.resize();
  }


  //modal helpers
  $ionicModal.fromTemplateUrl("templates/swap_modal.html", {
      scope:$scope
  }).then(modal => {
      $scope.modal = modal;
  });

  $ionicModal.fromTemplateUrl("templates/swap_modal_you.html", {
      scope:$scope
  }).then(modal => {
      $scope.modalYou = modal;
  });

  this.modalShipInfo = $ionicModal.fromTemplate(
    require("../../www/templates/swap_modal_shipinfo.html"),
    {
      scope:$scope
    }
  );

  $scope.$on('$destroy', () => {
      $scope.modal.remove();
      $scope.modalYou.remove();
      $scope.modalShipInfo.remove();
  });

  this.chooseCandidate = () => {

    this.loadCandidatesPage();
    this.toggledDetails = {};
    $scope.modal.show();
  }

  this.chooseYourCandidate = () => {
    this.loadYourCandidatesPage();
    this.toggledDetails = {};
    $scope.modalYou.show();
  }


  this.confirmProposal = () => {
    var confirmPopup = $ionicPopup.confirm({
     title: 'Proponi scambio',
     cancelText: 'Annulla',
     scope : $scope,
     template: `<p>Confermi la proposta di scambio?</p>
        <div class="item item-text-wrap">
        <p>
          Stai chiedendo {{SwapCtrl.you.items.length}} oggetti di <b>{{SwapCtrl.swapData.destinatario.nome}}</b> in cambio di {{SwapCtrl.me.items.length}} dei tuoi
          <span ng-if="SwapCtrl.me.money"> e {{SwapCtrl.me.money.ecoin}} €</span>. <br>
          Il valore totale dei tuoi oggetti è {{SwapCtrl.me.money.ecoin + SwapCtrl.getValues(SwapCtrl.me.items, SwapCtrl.objectsData)}}€ contro un valore totale di {{SwapCtrl.you.money.ecoin + SwapCtrl.getValues(SwapCtrl.you.items, SwapCtrl.objectsData)}} €
        </p>
        </div>
        <div ng-if="false && !swapCorrect()">
          <div class="item item-assertive item-text-wrap">
            <p class="white-text text-center">
            Attenzione: il valore degli oggetti non sembra congruo
            </p>
          </div>
        </div>
      </div>
      `
   });

   confirmPopup.then((res) => {
     if(res) {
       console.log('You are sure');
       this.confirmRequest()
     } else {
       console.log('You are not sure');
     }
   });
  }

  this.saveProposal = () => {
    console.log("saving existing", this.swapId)
    var confirmPopup = $ionicPopup.confirm({
     title: 'Modifica scambio',
     cancelText: 'Annulla',
     scope : $scope,
     template: `<p>Confermi la modifica alla proposta di scambio?</p>
        <div class="item item-text-wrap">
        <p>
          Stai chiedendo {{SwapCtrl.you.items.length}} oggetti di <b>{{SwapCtrl.swapData.destinatario.nome}}</b> in cambio di {{SwapCtrl.me.items.length}} dei tuoi
          <span ng-if="SwapCtrl.me.money"> e {{SwapCtrl.me.money.ecoin}} €</span>. <br>
          Il valore totale dei tuoi oggetti è {{SwapCtrl.me.money.ecoin + SwapCtrl.getValues(SwapCtrl.me.items, SwapCtrl.objectsData)}} € contro un valore totale di {{SwapCtrl.you.money.ecoin + SwapCtrl.getValues(SwapCtrl.you.items, SwapCtrl.objectsData)}} €
        </p>
        </div>
        <div ng-if="false && !swapCorrect()">
          <div class="item item-assertive item-text-wrap">
            <p class="white-text text-center">
            Attenzione: il valore degli oggetti non sembra congruo
            </p>
          </div>
        </div>
      </div>
      `
   });

   confirmPopup.then((res) => {

     if(res) {
       console.log('You are sure');
       console.log("saving existing", this.swapId)
       this.confirmRequest(this.swapId)
     } else {
       console.log('You are not sure');
     }
   });
  }


  this.confirmRequest = (swapId) => {
    let data = {
      user_from : {
        id : this.user.id,
        ecoin : this.me.money ? parseInt( this.me.money.ecoin || 0) : 0,
        items : _.map(this.me.items || [], item => item.oggetto.id )
      },
      user_to : {
        id : this.yourUser.id,
        ecoin : this.you.money ? parseInt(this.you.money.ecoin || 0) : 0,
        items : _.map(this.you.items || [], item => item.oggetto.id )
      }

    };

    $ionicLoading.show();

    let apiCall;
    if(!swapId){
      apiCall = DataService.swaps.post(data);
    } else {
      apiCall = DataService.swaps.one(swapId);
      apiCall.user_to = data.user_to;
      apiCall.user_from = data.user_from;
      apiCall = apiCall.put();
    }

    apiCall
    .then(resp => {
      console.log(resp)
      this.requestSent = resp;
      notifyManager.success("Proposta inviata");
    })
    .catch((err)=>{
      notifyManager.error("Errore invio proposta");
    })
    .finally(()=>{
      $ionicLoading.hide();
      this.canEdit = false;
    });

  };

  this.toRequestSent = () => {
    if(!this.requestSent || ! this.requestSent.id){
      return;
    }

    $ionicHistory.nextViewOptions({
        disableBack: true,
        historyRoot : true,
      });

    return $state.go("app.logged.swap", {
      swapId: this.requestSent.id
    })
  }


  this.refreshObjectsData = ()=>{
    let allItems = _.concat(this.me.items || [], this.you.items || []);
    let promises = [];

    _.each(allItems, it => {
      let oid = it.oggetto.id;
      if(!this.objectsData[oid]){
        let query = DataService.items.one(oid)
        .get({user_id:it.utente})
        .then(fullObj => {
          this.objectsData[oid] = fullObj.plain();
          return fullObj;
        })
        .catch(err => {
          this.objectsNotFound.push(oid)
        })
        promises.push(query);
      }
    })
    return $q.all(promises)

  }


  this.getValues = (source, data) => {
    let out = 0;
    _.each(source, item => {
      if(data[item.oggetto.id]){
        let g =  data[item.oggetto.id]
        out += parseInt(g.posseduto_da[0].valore)
      }
    })
    return out;
  }

  this.getImages = (obj, data) => {
    let f = data[obj.id];
    if(!f){
      return [];
    };
    let images = [];
    if(f.immagine) images.push(f.immagine);
    images = images.concat(f.altre_immagini || []);
    return images;
  }


  this.rejectProposal = () =>{

    $scope.tempData = {};
    $scope.tempData.tempReason = '';
    var rejectPopup = $ionicPopup.show({
      template: `<textarea noresize ng-model="tempData.tempReason">`,
        title: 'Rifiuto proposta',
        cancelText: 'Annulla',
        subTitle: 'Inserisci una motivazione',
        scope: $scope,
        buttons: [
          { text: 'Annulla', onTap : (e)=> {
            rejectPopup.close() }
          },
          {
            text: '<b>OK</b>',
            type: 'button-positive',
            onTap: (e) => {
              if (!$scope.tempData.tempReason) {
                e.preventDefault();
              } else {
                return $scope.tempData.tempReason;
              }
            }
          }
        ]
    });

    rejectPopup.then((res) => {
      if(!res){return}
      return DataService.swaps.one(this.swapId).all('actions/reject')
      .post({reason:res})
      .then((resp)=>{
        notifyManager.success("Richiesta rifiutata.")
        SwapCtrl.swapData.stato = 'rifiutata';
      })
    });
  }

  this.acceptProposal = () =>{

    $scope.tempData = {};
    $scope.tempData.tempReason = '';
    var acceptPopup = $ionicPopup.show({
        title: 'Accettazione proposta',
        subTitle: 'Confermi di accettare la proposta di scambio?',
        cancelText: 'Annulla',
        scope: $scope,
        buttons: [
          { text: 'Annulla', onTap : (e)=> {
            acceptPopup.close() }
          },
          {
            text: '<b>OK</b>',
            type: 'button-positive',
            onTap: (e) => {
              return true;
            }
          }
        ]
    });

    acceptPopup.then((res) => {
      if(!res){return}
      return DataService.swaps.one(this.swapId).all('actions/accept')
      .post({})
      .then((resp)=>{
        notifyManager.success("Richiesta accettata.")
        this.swapData.stato = 'accettata';
      })
    });
  }

  this.cancelProposal = () => {

    let confirmPopup = $ionicPopup.confirm({
     title: 'Annullamento proposta',
     template: 'Confermi l\'annullamento della proposta?'
   });

   confirmPopup.then(res => {
     if(res) {
       console.log('You are sure');
       return DataService.swaps
       .one(this.swapId)
       .all('actions/cancel')
       .post({})
       .then((resp)=>{
         notifyManager.success("Richiesta annullata.")
         this.swapData.stato = 'annullata';
       })
     }
   });

  }


  this.editProposal = () => {
    this.requestSent = null;
    $ionicScrollDelegate.scrollTop()
    this.canEdit = true;
  }

  this.cancelEditProposal = () => {
    $state.go(".", $stateParams, {reload:true});
  }

  this.goToItemDetail = (item) => {
    $state.go("app.logged.object", { objectId: item.oggetto.id, userId: this.user.id })
  };



}



// WEBPACK FOOTER //
// ./src/controllers/swap-controller.js